import { Pipe, type PipeTransform } from '@angular/core';
import type { Maybe } from '@quipex/core/primitives';
import { toSnakeCase } from '@quipex/shared/utils';

@Pipe({
    name: 'qpxSnakeCase',
})
export class SnakeCasePipe implements PipeTransform {
    /**
     * Transforms a given string to snake case, converting spaces to underscores and camelCase to snake_case.
     *
     * Example usage in a template:
     * ```
     * {{ 'Hello World' | qpxSnakeCase }}
     * {{ 'myCamelCase' | qpxSnakeCase }}
     * ```
     * This will render as:
     * ```
     * hello_world
     * my_camel_case
     * ```
     *
     * @param value - The input string to transform.
     * @returns The transformed string in snake_case.
     */
    transform(value: Maybe<string>): string {
        return toSnakeCase(value);
    }
}
